import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { SlaExpandedDetailGrid } from '~/app/landing/sla/shared/components/SlaExpandedDetailGrid';
import type {
  MaintenancePartnershipValidity,
  MaintenanceSlaContractRecord,
} from '~/app/landing/sla/oems/components/MaintenanceSlaContract/types';
import { useMaintenanceSlaHeaderItems } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/hooks/useMaintenanceSlaHeaderItems';
import { MaintenanceSlaLevelGroupsRead } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/components/MaintenanceSlaLevelGroupsRead/MaintenanceSlaLevelGroupsRead';
import { MaintenanceSlaScopeRulesRead } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/components/MaintenanceSlaScopeRulesRead/MaintenanceSlaScopeRulesRead';

export interface MaintenanceSlaContractReadProps {
  organizationId: string;
  contract: MaintenanceSlaContractRecord;
  partnership: MaintenancePartnershipValidity;
}

export function MaintenanceSlaContractRead({
  organizationId,
  contract,
  partnership,
}: MaintenanceSlaContractReadProps) {
  const { t } = useTranslation('sla');
  const items = useMaintenanceSlaHeaderItems(contract, partnership);

  return (
    <>
      {contract.rulesStatus === 'DRAFT' ? (
        <Alert
          style={{ marginBottom: 16 }}
          type="warning"
          showIcon
          message={t('oems.maintenance.draftBanner')}
        />
      ) : null}
      <SlaExpandedDetailGrid items={items} />
      <MaintenanceSlaLevelGroupsRead
        levels={contract.levels}
        interventionMode={contract.interventionMode}
        priceCurrency={contract.priceCurrency}
      />
      <MaintenanceSlaScopeRulesRead
        organizationId={organizationId}
        contract={contract}
      />
    </>
  );
}
